const szerokosc = { t: 'Szerokość', type: 'range', name: 'szerokosc', unit: 'm' }
export default szerokosc